import A from './components/A';
import C from './components/C';
import D from './components/D';
import Disclaimer from './components/Disclaimer';
import E from './components/E';
import F from './components/F';
import G from './components/G';
import H from './components/H';
import I from './components/I';
import J from './components/J';
import K from './components/K';
import L from './components/L';
import M from './components/M';
import MountingOptions from './components/MountingOptions';
import Nav from './components/Nav';
import O from './components/O';
import P from './components/P';
import PartnerBtnCN from './components/PartnerBtnCN';

export default function IndexDynamic() {
    return (
        <>
            <Nav />
            <A />
            <C />
            <D />
            <E />
            <F />
            <G />
            <H />
            <I />
            <J />
            <K />
            <MountingOptions />
            <L />
            <M />
            <O />
            <P />
            <PartnerBtnCN />
            <Disclaimer />
        </>
    );
}
